module.exports = __webpack_public_path__ + "static/media/flavour-map-background.c5ec7459.svg";